import React from 'react';
import PropTypes from 'prop-types';
import {isNil as _isNil} from 'lodash';

import Table from '@appComponents/Table';
import {sequenceConfigColumns} from '@modules/sequenceConfig/components/Table/SequenceConfigColumns';
import {IconEdit} from '@appComponents/IconCollection';
import Link, {getLink} from '@appComponents/Link';
import {CONFIGURATION_SEQUENCE} from '@constants/resources';
import {Authorization} from '@appComponents/Authorization';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';
import {convertToInt} from '@utils/helpers';

const authorizationObject = {
    [CONFIGURATION_SEQUENCE]: SECURITY_PRIVILEGES_READ,
};

export const SequenceConfigTable = ({loading, sequences}) => {
    return (
        <div className='table-container'>
            <Table
                columns={sequenceConfigColumns}
                name={'sequencesList'}
                loading={loading}
                data={sequences}
                rowRenderer={rowRenderer}
                noDataText={'No sequence configurations found'}
            />
        </div>
    );
};

SequenceConfigTable.propTypes = {
    loading: PropTypes.bool,
    sequences: PropTypes.array,
};

const rowRenderer = (column, row) => {
    switch (column) {
        case 'id': return convertToInt(row.id);
        case 'start_delay':
        case 'stop_delay': return (!_isNil(row[column]) ? `${row[column]}s` : null);
        case 'cutoff': return (!_isNil(row[column]) ? `${row[column]} min` : null);
        case 'name': return <Link name='sequenceConfigs.edit' params={{id: row.id}}>{row[column]}</Link>;
        case 'data_source': return row.sequence_data_source?.name;
        case 'actions': {
            return (
                <Authorization authorization={authorizationObject}>
                    <div className='actions-list-icon'>
                        <IconEdit
                            size='large'
                            link={getLink('sequenceConfigs.edit', {id: row.id})}
                            resource={CONFIGURATION_SEQUENCE}
                        />
                    </div>
                </Authorization>
            );
        }
    }
};
